// extracted by mini-css-extract-plugin
module.exports = {"baseMenuSection":"BaseMenuSection_baseMenuSection__fjVuu","baseMenuDivider":"BaseMenuSection_baseMenuDivider__apIUd","linkContainer":"BaseMenuSection_linkContainer__lGeuU"};